// src/components/ReviewsSlider.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import ReviewsCarousel from './ReviewsCarousel';

function getReviews(lang) {
  const ru = [
    {
      name: 'Алина Корнилова',
      role: 'Руководитель продукта, IT',
      text: 'Быстро подобрали квартиру под аренду и закрыли сделку за неделю. Отдельное спасибо за прозрачные условия и аккуратные документы.',
    },
    {
      name: 'Иван Романов',
      role: 'Основатель стартапа',
      text: 'Ребята сделали сложную продажу без стресса. Глубокая аналитика и чёткий план действий — чувствовался контроль на каждом шаге.',
    },
    {
      name: 'Мария Белова',
      role: 'Финансовый директор',
      text: 'Помогли с инвестированием в апартаменты в Дубае. Понравилась прозрачность по доходности и грамотная юридическая поддержка.',
    },
    {
      name: 'Егор Данилов',
      role: 'Маркетинг-директор',
      text: 'Показали редкие варианты в центре, которых не было в открытом доступе. Сделка прошла мягко и оперативно.',
    },
    {
      name: 'Ольга Фомина',
      role: 'HR-директор',
      text: 'Сопроводили обмен двух объектов. Чёткая коммуникация, бережное отношение ко времени и интересам клиента.',
    },
    {
      name: 'Никита Полевой',
      role: 'Адвокат',
      text: 'Юридический блок на уровне: договоры, риски, сроки — всё аккуратно и по делу. Рекомендую.',
    },
  ];

  const en = [
    {
      name: 'Alice Morton',
      role: 'Product Manager',
      text: 'Found a perfect rental quickly and closed in a week. Transparent process and precise paperwork.',
    },
    {
      name: 'David Brooks',
      role: 'Founder',
      text: 'They handled a complex sale smoothly. Clear strategy and constant control at each step.',
    },
    {
      name: 'Sophia Lee',
      role: 'Finance Director',
      text: 'Great advisory on investing in Dubai apartments. Realistic yields and strong legal support.',
    },
    {
      name: 'Mark Johnson',
      role: 'Marketing Lead',
      text: 'Showed off-market options downtown. Fast and seamless transaction.',
    },
    {
      name: 'Olivia Brown',
      role: 'HR Director',
      text: 'Supported a two-property swap with flawless communication and timing.',
    },
    {
      name: 'Leo Carter',
      role: 'Attorney',
      text: 'Legal block was crystal clear: contracts, risks, deadlines. Highly recommend.',
    },
  ];

  const zh = [
    {
      name: '李娜',
      role: '产品经理',
      text: '快速找到了完美的租赁房产，一周内完成交易。流程透明，文件精确。',
    },
    {
      name: '王浩',
      role: '创始人',
      text: '他们顺利处理了复杂的销售。清晰的策略和每一步的持续控制。',
    },
    {
      name: '张美玲',
      role: '财务总监',
      text: '在迪拜公寓投资方面提供了出色的建议。实际的收益率和强大的法律支持。',
    },
    {
      name: '刘强',
      role: '市场总监',
      text: '展示了市中心的非公开房源。快速无缝的交易。',
    },
    {
      name: '陈静',
      role: '人力资源总监',
      text: '支持了两处房产的交换，沟通和时间安排完美无瑕。',
    },
    {
      name: '赵明',
      role: '律师',
      text: '法律部分非常清晰：合同、风险、截止日期。强烈推荐。',
    },
  ];

  return lang === 'zh' ? zh : (lang === 'ru' ? ru : en);
}

export default function ReviewsSlider({
  lng,
  // адаптивные пропсы по умолчанию: 3 на десктопе → 2 планшет → 1 мобилка
  perViewDesktop = 3,
  perViewTablet  = 2,
  perViewMobile  = 2,
  perViewTiny    = 1,
  // тонкая настройка карточки/контейнера (можно не трогать)
  itemMin = 260,
  itemMax = 330,
  maxWidth = '100%',
  bpTiny = 640,
  bpTablet = 1000,
  autoplay = true,
  autoplayIntervalMs = 5000,
  pauseOnHover = true,
}) {
  const { i18n } = useTranslation();
  const currentLang = lng || i18n.language || 'ru';
  
  // Определяем язык: zh, ru или en
  let L = 'en';
  if (currentLang.startsWith('zh') || currentLang === 'zh') {
    L = 'zh';
  } else if (currentLang.startsWith('ru') || currentLang === 'ru') {
    L = 'ru';
  }
  
  const items = React.useMemo(() => getReviews(L), [L]);

  return (
    <ReviewsCarousel
      title=""
      items={items}
      perViewDesktop={perViewDesktop}
      perViewTablet={perViewTablet}
      perViewMobile={perViewMobile}
      perViewTiny={perViewTiny}
      itemMin={itemMin}
      itemMax={itemMax}
      maxWidth={maxWidth}
      bpTiny={bpTiny}
      bpTablet={bpTablet}
      autoplay={autoplay}
      autoplayIntervalMs={autoplayIntervalMs}
      pauseOnHover={pauseOnHover}
    />
  );
}
